module.exports = "<section class=initial-onboarding-hero> <div class=initial-onboarding-hero__content> <h1 class=heading-h1 ng-bind=heading></h1> </div> </section> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/auth/directives/auth-hero/auth-hero.html
// module id = 365
// module chunks = 0